module.exports = __webpack_public_path__ + "static/media/icon-trash-red-blur.40000cb5.svg";